import { ControlFacet } from '../models/controls/ControlFacet';
import { IActionInput } from '../components/withAction/WithAction';

export const sharedFieldClickActionControl: ControlFacet<{
  itemKey: string;
}, {
    onClickAction?: IActionInput;
  }> = new ControlFacet('sharedFieldClickActionControl');
